<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <app-product-card-ellipsis
        [notFound]="product?.notFound"
        (ellipsisClickEmitter)="ellipsisClickTouch($event)"
        [isGuestUser]="false"
      >
      </app-product-card-ellipsis>
    </ion-buttons>

    <ion-label data-cy="ingredient-product-name-text">
      {{
        product?.summary?.productDescTxtl ??
          product?.summary?.productDescLong ??
          '' | truncateWithEllipsis: (platform === platformRef.mobile ? 26 : 50)
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  tabletTouchMove
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="header">
    <app-ingredient-detail-touch-header
      [platform]="platform"
      [product]="product"
      [isOnline]="isOnline"
      [cardData]="cardData"
      [selectedTab]="selectedTab"
      [pricingDisabled]="pricingDisabled"
      (ellipsisEvent)="ellipsisClick($event)"
      (productEvent)="onProductTouchClick($event)"
      (noteInputBlurEvent)="handleNoteuUpdate($event)"
      (quantityInputBlurEvent)="handleQuantityUpdate($event)"
      (uomDropdownClickEvent)="handleUOMUpdate($event)"
    >
    </app-ingredient-detail-touch-header>
  </div>
  <div class="container">
    <app-ingredient-detail-touch-actions
      [platform]="platform"
      [dataItems]="actions"
      [title]="currentActionsTitle"
      [selectedTab]="selectedTab"
      (tabSelectedEvent)="updateTab($event)"
    ></app-ingredient-detail-touch-actions>
    <app-ingredient-units-of-measure
      *ngIf="selectedTab === 'unit-of-measure'"
      [platform]="platform"
      [baseUnit]="currentCalculations?.displayBaseUnit"
      [baseQuantity]="currentCalculations?.baseQuantity"
      [conversionUnit]="currentCalculations?.displayConversionUnit"
      [conversionQuantity]="currentCalculations?.conversionQunatity"
      [solvedUnit]="currentCalculations?.displayTestUnit"
      [solvedQuantity]="currentCalculations?.testQuantity"
      [solvedCost]="currentCalculations?.testCost"
      [baseUnits]="currentCalculations?.allowedUnits"
      [conversionUnits]="currentCalculations?.possibleConversionUnits"
      (baseQuantityEvent)="updateBaseQunatity($event)"
      (conversionQuantityEvent)="updateConversionQuantity($event)"
      (baseUnitEvent)="updateBaseUnit($event)"
      (conversionUnitEvent)="updateConversionUnit($event)"
      (resultUnitEvent)="updateResultsUnit($event)"
      (saveChangesEvent)="saveUnitsOfMeasureCalculation()"
      (infoIconEvent)="clickInfoIcon($event)"
    ></app-ingredient-units-of-measure>
  </div>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-edit-details-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="save-modal-btn"
        data-cy="save-edit-details-modal-button"
        [ngClass]="
          selectedTab === 'default' ||
          (selectedTab === 'unit-of-measure' &&
            (!currentCalculations?.baseQuantity ||
              !currentCalculations?.conversionQunatity ||
              !currentCalculations?.baseUnit ||
              !currentCalculations?.conversionUnit))
            ? platform !== platformRef.mobile
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-disabled-mobile-modal-button'
            : platform !== platformRef.mobile
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-green-mobile-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
